import { Button, Icon, InlineLink, Surface, Txt } from '@vst/beam';
import { CheckMark } from '@vst/beam-icons/illustrative-icons';

import styles from './ecaSuccessModal.module.scss';

type EcaSuccessModalProps = {
  isOpen: boolean;
  showScheduleButton: boolean;
  isServiceable?: boolean;
  handleSchedule: () => void;
  t: (key: string) => string;
};

export const EcaSuccessModal = ({
  isOpen,
  showScheduleButton,
  handleSchedule,
  isServiceable,
  t,
}: EcaSuccessModalProps) => {
  if (!isOpen) {
    return null;
  }
  return (
    <div data-cy={'eca-success-modal'} className={styles['empty-state']}>
      <div className={styles['modal-content']}>
        <Surface
          className={styles['success-surface']}
          p="32px"
          variant="secondary"
        >
          <Icon
            icon={CheckMark}
            size={96}
            color={'teal_600'}
            mb={'32px'}
            data-cy={'success-empty-state-eca-icon'}
          />
          <Txt
            variant="heading4"
            color={'subtle'}
            mb={'8px'}
            data-cy={'success-empty-state-eca-header'}
            className={styles['header']}
          >
            {t('successModal.header')}
          </Txt>
          <Txt
            variant={'bodyLargeRegular'}
            className={styles['subheader']}
            data-cy={'success-empty-state-eca-description'}
            mb={'32px'}
          >
            {isServiceable ? t('successModal.description') : ''}
          </Txt>
          {showScheduleButton && (
            <Button
              onClick={handleSchedule}
              variant="primary"
              className={styles['button']}
              mb={'24px'}
            >
              {t('successModal.scheduleInstallation')}
            </Button>
          )}
          <InlineLink href={'/'} className={styles['link']}>
            {t('successModal.backToDashboard')}
          </InlineLink>
        </Surface>
      </div>
    </div>
  );
};
